
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.21.1
 * Query Engine version: bf0e5e8a04cada8225617067eaa03d041e2bba36
 */
Prisma.prismaVersion = {
  client: "5.21.1",
  engine: "bf0e5e8a04cada8225617067eaa03d041e2bba36"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  zapierId: 'zapierId',
  accountIds: 'accountIds',
  isStaff: 'isStaff',
  isAdmin: 'isAdmin',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  avatarUrl: 'avatarUrl',
  subscriptionPending: 'subscriptionPending',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  expiresAt: 'expiresAt',
  lastSeenAt: 'lastSeenAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserTokenScalarFieldEnum = {
  userId: 'userId',
  accountId: 'accountId',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  expiresAt: 'expiresAt'
};

exports.Prisma.ProjectScalarFieldEnum = {
  id: 'id',
  name: 'name',
  publicName: 'publicName',
  slug: 'slug',
  customDomain: 'customDomain',
  accountId: 'accountId',
  creatorId: 'creatorId',
  appearance: 'appearance',
  password: 'password',
  secret: 'secret',
  homepageId: 'homepageId',
  restrictEmbedDomains: 'restrictEmbedDomains',
  embedHosts: 'embedHosts',
  authType: 'authType',
  captchaEnabled: 'captchaEnabled',
  stytchOrganizationId: 'stytchOrganizationId',
  googleAnalyticsTrackingId: 'googleAnalyticsTrackingId',
  hideZapierButton: 'hideZapierButton',
  favicon: 'favicon',
  logo: 'logo',
  globalNavigation: 'globalNavigation',
  includeLogo: 'includeLogo',
  linkedPageIds: 'linkedPageIds',
  navigationLinks: 'navigationLinks',
  isHidden: 'isHidden',
  themeId: 'themeId',
  stripeConnectedAccountId: 'stripeConnectedAccountId',
  loginPageId: 'loginPageId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ThemeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  preset: 'preset',
  mode: 'mode',
  brandColor: 'brandColor',
  radius: 'radius',
  background: 'background',
  foreground: 'foreground',
  card: 'card',
  cardForeground: 'cardForeground',
  popover: 'popover',
  popoverForeground: 'popoverForeground',
  primary: 'primary',
  primaryForeground: 'primaryForeground',
  secondary: 'secondary',
  secondaryForeground: 'secondaryForeground',
  muted: 'muted',
  mutedForeground: 'mutedForeground',
  accent: 'accent',
  accentForeground: 'accentForeground',
  destructive: 'destructive',
  destructiveForeground: 'destructiveForeground',
  border: 'border',
  input: 'input',
  ring: 'ring',
  darkBackground: 'darkBackground',
  darkForeground: 'darkForeground',
  darkCard: 'darkCard',
  darkCardForeground: 'darkCardForeground',
  darkPopover: 'darkPopover',
  darkPopoverForeground: 'darkPopoverForeground',
  darkPrimary: 'darkPrimary',
  darkPrimaryForeground: 'darkPrimaryForeground',
  darkSecondary: 'darkSecondary',
  darkSecondaryForeground: 'darkSecondaryForeground',
  darkMuted: 'darkMuted',
  darkMutedForeground: 'darkMutedForeground',
  darkAccent: 'darkAccent',
  darkAccentForeground: 'darkAccentForeground',
  darkDestructive: 'darkDestructive',
  darkDestructiveForeground: 'darkDestructiveForeground',
  darkBorder: 'darkBorder',
  darkInput: 'darkInput',
  darkRing: 'darkRing',
  darkModeEnabled: 'darkModeEnabled',
  inputField: 'inputField',
  inputFieldForeground: 'inputFieldForeground',
  darkInputField: 'darkInputField',
  darkInputFieldForeground: 'darkInputFieldForeground'
};

exports.Prisma.ConsumerScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  email: 'email',
  avatar: 'avatar',
  name: 'name'
};

exports.Prisma.PageScalarFieldEnum = {
  id: 'id',
  name: 'name',
  title: 'title',
  slug: 'slug',
  projectId: 'projectId',
  navigationEnabled: 'navigationEnabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BlockScalarFieldEnum = {
  id: 'id',
  type: 'type',
  config: 'config',
  pageId: 'pageId',
  order: 'order',
  parentId: 'parentId',
  blockStateId: 'blockStateId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BlockActionScalarFieldEnum = {
  id: 'id',
  type: 'type',
  config: 'config',
  blockId: 'blockId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BlockStateScalarFieldEnum = {
  id: 'id',
  type: 'type',
  pageId: 'pageId',
  state: 'state',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FormSubmissionScalarFieldEnum = {
  id: 'id',
  blockId: 'blockId',
  recordId: 'recordId',
  tableId: 'tableId',
  values: 'values',
  consumerId: 'consumerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CollaboratorScalarFieldEnum = {
  zapierId: 'zapierId',
  projectId: 'projectId',
  createdAt: 'createdAt'
};

exports.Prisma.RestHookSubscriptionScalarFieldEnum = {
  id: 'id',
  url: 'url',
  accountId: 'accountId',
  projectId: 'projectId',
  pageId: 'pageId',
  blockType: 'blockType',
  blockId: 'blockId',
  blockActionId: 'blockActionId',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadedFileScalarFieldEnum = {
  uuid: 'uuid',
  key: 'key',
  projectId: 'projectId',
  userId: 'userId',
  blockId: 'blockId',
  blockType: 'blockType',
  formSubmissionId: 'formSubmissionId',
  consumerId: 'consumerId',
  sourceTemplate: 'sourceTemplate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountOverrideScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  plan: 'plan',
  paidFeatureAccess: 'paidFeatureAccess',
  projectLimit: 'projectLimit',
  pageLimit: 'pageLimit',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.Page_migrationsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  applied_at: 'applied_at'
};

exports.Prisma.StripeConnectedAccountScalarFieldEnum = {
  id: 'id',
  zapierAccountId: 'zapierAccountId',
  stripeAccountId: 'stripeAccountId',
  stripeAccountEmail: 'stripeAccountEmail',
  createdByZapierId: 'createdByZapierId',
  createdByInterfacesUserId: 'createdByInterfacesUserId',
  termsVersion: 'termsVersion',
  termsUrl: 'termsUrl',
  termsDate: 'termsDate',
  status: 'status',
  taxStatus: 'taxStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.ProjectAuthType = exports.$Enums.ProjectAuthType = {
  None: 'None',
  Password: 'Password',
  Consumer: 'Consumer',
  Stytch: 'Stytch'
};

exports.ThemePreset = exports.$Enums.ThemePreset = {
  Default: 'Default',
  Black: 'Black',
  Purple: 'Purple',
  Green: 'Green',
  Red: 'Red',
  Orange: 'Orange',
  Brand: 'Brand',
  Custom: 'Custom'
};

exports.ThemeMode = exports.$Enums.ThemeMode = {
  Light: 'Light',
  Dark: 'Dark',
  System: 'System'
};

exports.BlockType = exports.$Enums.BlockType = {
  MarkdownText: 'MarkdownText',
  Links: 'Links',
  LinksCard: 'LinksCard',
  TableListing: 'TableListing',
  Kanban: 'Kanban',
  Form: 'Form',
  Field: 'Field',
  Chatbot: 'Chatbot',
  Media: 'Media',
  Divider: 'Divider',
  Embed: 'Embed',
  Button: 'Button',
  Checklist: 'Checklist',
  Layout: 'Layout',
  StripePayment: 'StripePayment',
  LoginForm: 'LoginForm',
  AIGenerated: 'AIGenerated'
};

exports.BlockActionType = exports.$Enums.BlockActionType = {
  Navigate: 'Navigate',
  Notify: 'Notify',
  OpenExternalUrl: 'OpenExternalUrl'
};

exports.RestHookSubscriptionType = exports.$Enums.RestHookSubscriptionType = {
  ProjectCreated: 'ProjectCreated',
  PageCreated: 'PageCreated',
  BlockCreated: 'BlockCreated',
  FormCreated: 'FormCreated',
  FormSubmissionCreated: 'FormSubmissionCreated',
  ConsumerCreated: 'ConsumerCreated',
  ButtonClicked: 'ButtonClicked',
  StripePaymentProcessed: 'StripePaymentProcessed'
};

exports.AccountPlan = exports.$Enums.AccountPlan = {
  premium: 'premium',
  advanced: 'advanced',
  platform_pro: 'platform_pro',
  platform_team: 'platform_team',
  platform_enterprise_core: 'platform_enterprise_core',
  platform_enterprise_standard: 'platform_enterprise_standard',
  platform_enterprise_plus: 'platform_enterprise_plus',
  platform_enterprise_max: 'platform_enterprise_max'
};

exports.PaidFeature = exports.$Enums.PaidFeature = {
  customColors: 'customColors',
  branding: 'branding',
  embedding: 'embedding',
  customDomain: 'customDomain',
  analytics: 'analytics',
  customTokenLength: 'customTokenLength',
  passwordProtect: 'passwordProtect',
  managedUsers: 'managedUsers',
  chatBotDataSources: 'chatBotDataSources',
  hideZapierButton: 'hideZapierButton',
  dynamicFilters: 'dynamicFilters',
  collaborators: 'collaborators',
  conditionalLogic: 'conditionalLogic',
  fileSizeLimit10mb: 'fileSizeLimit10mb',
  fileSizeLimit25mb: 'fileSizeLimit25mb',
  extendedFileUploads: 'extendedFileUploads',
  embedBlock: 'embedBlock',
  layoutBlock: 'layoutBlock',
  stripePayment: 'stripePayment',
  stytchAuth: 'stytchAuth',
  projectMagicLinkAuth: 'projectMagicLinkAuth',
  projectSignInWithGoogleAuth: 'projectSignInWithGoogleAuth',
  projectApprovedDomainsAuth: 'projectApprovedDomainsAuth'
};

exports.StripeConnectedAccountStatus = exports.$Enums.StripeConnectedAccountStatus = {
  Disabled: 'Disabled',
  NeedsMoreInfo: 'NeedsMoreInfo',
  Enabled: 'Enabled',
  PendingVerification: 'PendingVerification'
};

exports.StripeConnectedAccountTaxStatus = exports.$Enums.StripeConnectedAccountTaxStatus = {
  Active: 'Active',
  Pending: 'Pending',
  Inactive: 'Inactive'
};

exports.Prisma.ModelName = {
  User: 'User',
  UserToken: 'UserToken',
  Project: 'Project',
  Theme: 'Theme',
  Consumer: 'Consumer',
  Page: 'Page',
  Block: 'Block',
  BlockAction: 'BlockAction',
  BlockState: 'BlockState',
  FormSubmission: 'FormSubmission',
  Collaborator: 'Collaborator',
  RestHookSubscription: 'RestHookSubscription',
  UploadedFile: 'UploadedFile',
  AccountOverride: 'AccountOverride',
  page_migrations: 'page_migrations',
  StripeConnectedAccount: 'StripeConnectedAccount'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
